import Select, { components } from "react-select";
import React, { memo, useRef, useState } from "react";
import { Controller } from "react-hook-form";
import { current } from "@reduxjs/toolkit";
const CustomAutoCompleteTextSelect = (props) => {
    const CustomDropdownIndicator = () => null;
    const selectRef = useRef(null);
    const colourStyles = {
        indicatorsContainer: (styles) => ({
            ...styles,
            maxHeight: 40,
        }),
        input: (styles, data) => ({
            ...styles,
            marginTop: "-2%",
            marginLeft: "0%"
        }),
        control: (styles) => ({
            ...styles,
            width: "100%",
            height: "40px",
            cursor: "pointer",
            minHeight: "40px",
            maxHeight: "auto",
            color: "#595959",
            background: "#fff",
            border: "1px solid #a09f9f",
            borderRadius: "2px",
            justifyContent: "space-between",
            outline: "0.5px solid white !important",
            "&:hover": {
                color: "#595959 !important",
                boxShadow: "none !important",
                backgroundColor: "#fafafa !important",
                border: "1px solid #595959 !important",
                outline: "none !important",
            },
            "&:focus": {
                backgroundColor: "none",
                outline: "1px solid #595959 !important",
            },
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
            ...styles,
            "&:hover": {
                backgroundColor: "#fffaeb",
                fontWeight: "600",
                boxShadow: "none !important",
                outline: "1px solid #595959 !important",
            },
            "&:focus": {
                backgroundColor: "#fffaeb",
                fontWeight: "600",
                boxShadow: "none !important",
                outline: "1px solid #595959 !important",
            },
            color: "#231f20",
            cursor: "pointer",
            height: "auto !important",
            marginTop: "-2px",
            marginBottom: "-2.5px",
            backgroundColor: isFocused ? "#fffaeb" : "transparent",
        }),
        menu: (base) => ({
            ...base,
            marginTop: "1px",
            minWidth: "100%",
            minHeight: "100%",
            outline: "1px solid #595959 !important",
            borderRadius: "0px"
        }),
        indicatorSeparator: () => ({
            display: 'none',
        }),
        dropdownIndicator: () => ({
            display: 'none',
        }),
    };

    const [selectAll, setSelectAll] = useState(false);
    const handleKeyDown = (event) => {
        if (event.ctrlKey && (event.key === 'a' || event.key === 'Control')) {
            event.preventDefault();
            // Select all text
            if (selectRef1.current) {
                const input = selectRef1.current.inputRef;
                input.setSelectionRange(0, input.value.length);
                setSelectAll(true);
            }
        }
        if (selectAll && (event.key === 'Delete' || event.key === 'Backspace')) {
            if (inputValue) {
                setInputValue("");
                props?.setValue(props?.fieldName, { value: '', label: '' });
                props?.trigger(props?.fieldName);
            }
            if (props?.isDynamicSearch) {
                props?.setValue(props?.fieldName, "");
                props?.trigger(props?.fieldName);
            }
        }
    };

    const [inputValue, setInputValue] = useState('');
    const selectRef1 = useRef(null);

    const AlterLabelForExternalUser = (label) => {
        return props?.internalUser ? label : label?.replace(/\s*\[\d+\]\s*\(\s*(active|inactive)\s*\)\s*$/i, '');
    }

    return !props?.isDynamicSearch ? (
        <>
            <div id={props?.name} tabIndex="-1" ref={selectRef}>
                <div className="flex flex-row">
                    <div className="flex flex-col w-auto font-semibold">{props?.labelName}</div>
                    <div className="flex flex-col minWidth80 pl-2">
                        <Controller
                            control={props?.control}
                            name={props?.fieldName}
                            render={
                                ({ field }) => (
                                    <Select
                                        {...field}
                                        ref={selectRef1}
                                        styles={colourStyles}
                                        options={props?.options}
                                        inputValue={inputValue}
                                        onInputChange={(value) => {
                                            if (value !== "") {
                                                setInputValue(value);
                                                props?.setValue(props?.fieldName, { value: value, label: value });
                                                props?.trigger(props?.fieldName);
                                            }
                                            else if (value === "" && inputValue?.length === 1) {
                                                setInputValue("");
                                                props?.setValue(props?.fieldName, { value: "", label: "" });
                                                props?.trigger(props?.fieldName);
                                            }
                                            setSelectAll(false);
                                        }
                                        }
                                        onChange={(selectedOption) => {
                                            props?.DropdownChanged(selectedOption);
                                            field.onChange(selectedOption);
                                            props?.setValue(props?.fieldName, selectedOption);
                                            props?.trigger(props?.fieldName);
                                            setInputValue('');
                                            setTimeout(() => {
                                                if (selectRef1?.current) {
                                                    selectRef1?.current.blur();
                                                }
                                            }, 0);

                                        }}
                                        onBlur={() => {
                                            if (inputValue) {
                                                const newOption = { value: inputValue, label: inputValue };
                                                props?.setValue(props?.fieldName, newOption);
                                                props?.trigger(props?.fieldName);
                                                setInputValue('');
                                                props?.setIsDropdownSelectedLender(false)

                                            }
                                        }}
                                        placeholder={props?.placeholder}
                                        menuIsOpen={inputValue?.length > 0}
                                        noOptionsMessage={() => props?.NoOptionDisplayNotRequired ? null : props?.t('NoOptionFound')}
                                        onFocus={() => {
                                            // Ensure the cursor is at the end of the input value
                                            setInputValue(props?.getValues(props?.fieldName)?.label);
                                        }}
                                        onKeyDown={handleKeyDown} // Add keydown handler
                                    />
                                )
                            }
                        />
                    </div>

                </div>
                <div className="flex flex-row pt-2">
                    <div className="flex flex-col">{props?.errors?.type === "LenderAdminAndOrtest" && (<svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="relative top-0 "
                        width="30"
                        height="22"
                        fill="none"
                    >
                        <g
                            clipPath="url(#clip0_2775_161095)"
                            stroke="#E2211C"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M10.995 20.17a9.167 9.167 0 1 0 0-18.334 9.167 9.167 0 0 0 0 18.333ZM11 7.336v3.667M11 14.664h.01" />
                        </g>
                        <defs>
                            <clipPath id="clip0_2775_161095">
                                <rect width="30" height="22" fill="#fff" />
                            </clipPath>
                        </defs>
                    </svg>)}</div>
                    <div className="flex flex-col"><span className='custom__dropdown-wrapper font-semibold text-secondary-red'>
                        {props?.errorMessage}
                    </span></div>
                </div>
            </div>
        </>
    ) : (
        <>
            <div id={props?.name} tabIndex="-1" ref={selectRef}>
                <Controller
                    control={props?.control}
                    name={props?.fieldName}
                    render={
                        ({ field }) => (
                            <Select
                                {...field}
                                ref={selectRef1}
                                styles={colourStyles}
                                options={props?.options}
                                inputValue={(props?.value ? AlterLabelForExternalUser(props?.value) : AlterLabelForExternalUser(inputValue)) || ""}
                                onInputChange={(value) => {
                                    if (value !== "") {
                                        setInputValue(value);
                                        props?.setValue(props?.fieldName, value);
                                        props?.trigger(props?.fieldName);
                                    }
                                    else if (value === "" && (props?.value === "" || !props?.value || (value === "" && props?.value?.length === 1))) {
                                        setInputValue("");
                                        props?.setValue(props?.fieldName, "");
                                        props?.trigger(props?.fieldName);
                                    }
                                    props?.isDynamicSearch && value && value?.length > 0 && props?.onDynamicSearch(value);
                                    setSelectAll(false);
                                }
                                }
                                onChange={(selectedOption) => {
                                    props?.DropdownChanged(selectedOption);
                                    field.onChange(selectedOption);
                                    props?.setValue(props?.fieldName, selectedOption?.label?.trim());
                                    props?.trigger(props?.fieldName);
                                    setInputValue(selectedOption?.label?.trim());
                                    setTimeout(() => {
                                        if (selectRef1?.current) {
                                            selectRef1?.current.blur();
                                            selectRef1?.current.focus();
                                        }
                                    }, 0);

                                }}
                                onBlur={() => {
                                    if (props?.getValues(props?.fieldName)) {
                                        props?.setValue(props?.fieldName, props?.getValues(props?.fieldName));
                                        props?.trigger(props?.fieldName);
                                        setInputValue('');
                                        props?.setIsDropdownSelectedLender(false)
                                    }

                                }}
                                formatOptionLabel={(option) => {
                                    const cleanedLabel = AlterLabelForExternalUser(option?.label);
                                    return cleanedLabel;
                                }}

                                placeholder={props?.placeholder}
                                menuIsOpen={inputValue?.length > 0}
                                noOptionsMessage={() => props?.t('NoOptionFound')}
                                onFocus={() => {
                                    // Ensure the cursor is at the end of the input value
                                    setInputValue('');
                                }}
                                onKeyDown={handleKeyDown} // Add keydown handler
                            />
                        )
                    }
                />
                <span className='custom__dropdown-wrapper font-semibold text-secondary-red'>
                    {props?.errorMessage}
                </span>
            </div>
        </>
    )
};

export default memo(CustomAutoCompleteTextSelect);
